import { Component, createRef } from "react";
import Signbutton from "../forms/button";
import { Input } from "../forms/input";
import { connect } from "react-redux";
import {
  userLogin,
  validateLoginOtp,
  generateLoginOtp,
  validateOTP,
  userLogout,
} from "../../store/actions";
import { REQ_BY } from "../../store/types";
import { DASHBOARD_URL } from "../home/dashboard";
import CustomLoader from "../forms/Loader";
import Image from "../Image";
import EmailMobileRegistration from "./emailMobileRegistration";
import { PosterDialog } from "../home/customModal";
var jwt = require("jsonwebtoken");
export const SITE_KEY =
  process.env.REACT_APP_SITE_KEY || "6Le8fBwUAAAAAKu91bg0p7vZ0Z2e35XilDpTwv0z";
var TWO_FA_ENABLED = true;
class Login extends Component {
  constructor(props) {
    super(props);
    const currentTime = new Date();
    const cutoffTime = new Date("2025-07-28T23:59:59");
    this.state = {
      username: { value: "" },
      password: { value: "" },
      showPassword: false,
      PosterOpen: true,
      display: false,
      displayOTP: false,
      otp: { value: "" },
      open: false,
      Otpdata: { value: "" },
      displayPoster: currentTime <= cutoffTime,
    };
  }
  captchaRef = createRef(null);

  changeValue = (label) => (event) => {
    if (event.target.value.length <= 45) {
      this.setState({
        [label]: { value: event.target.value },
      });
    }
  };

  showError = (label) => (event) => {
    const {
      [label]: { value },
    } = this.state;
    this.setState({
      [label]: {
        value,
        isError: !value,
        errorMessage: `${
          label === "username"
            ? "User ID"
            : label === "password"
            ? "Password"
            : label
        } is mandatory`,
      },
    });
  };
  generateOTP = async () => {
    this.setState({
      display: true
    })
    const payload = {
      username: encrypt(this.state.username.value),
      password: encrypt(this.state.password.value),
      ReqBy: REQ_BY,
    };

    const { username, password } = this.state;

    if (!username.value || !password.value) {
      return;
    }

    const response = await this.props.userLogin(payload);
   
    if (response?.code === "SKIP_DIST_LOGIN") {
      const { DtData = [] } = response;
      if (DtData[0].tran_enable_flag === "N") {
        this.props.history.push(DASHBOARD_URL);
      } else {
        this.props.history.push(`/new-transaction`);
      }
      return;
    }

    if (response?.code === "NO_DIST_EMAIL_MOBILE") {
      this.setState({
        open: true,        
        display: false,
      });
      return;
    }
    if (!response.otpId) {
      this.setState({
        display: false,
        username: {
          value: "",
          isError: true,
          errorMessage: "Please enter valid details",
        },
        password: {
          value: "",
          isError: true,
          errorMessage: "Please enter valid details",
        },
      });
      return;
    }
    this.setState({
      display: false,
      displayOTP: true,
      Otpdata: { value: response },
    });
  };

  signIn = async () => {
    const {
      showPassword,
      PosterOpen,
      display,
      otp,
      displayOTP,
      open,
      Otpdata,
      displayPoster,
      ...others
    } = this.state;
    const keys = Object.keys(others);
    const findError = keys.every((key) => {
      return !!this.state[key].value;
    });
    if (!findError) {
      keys.forEach((key) => {
        !this.state[key].value &&
          this.setState({
            [key]: {
              ...this.state[key],
              isError: true,
              errorMessage: `${
                key === "username"
                  ? "User ID"
                  : key === "password"
                  ? "Password"
                  : key
              } is mandatory`,
            },
          });
      });
      const firstErroredKey = keys.find((key) => !this.state[key].value);
      switch (firstErroredKey) {
        case "username":
          this.usernameField.focus();
          break;
        case "password":
          this.passwordField.focus();
          break;
      }
    } else {
      const nonce = Math.floor(100000 + Math.random() * 900000);
      try {
        this.setState({
          display: true,
          nonce,
        });

        const payload = {
          otpId: encrypt(Number(Otpdata.value.otpId)),
          otp: encrypt(Number(this.state.otp.value)),
          username: encrypt(this.state.username.value),
          nonce: encrypt(nonce),
        };

        const response = await this.props.validateOTP(payload);
        if (response && String(response?.nonce) !== String(this.state.nonce)) {
          this.setState({
            display: false,
            username: { value: "" },
            password: { value: "" },
          });
          alert("Unauthorized Request");
          return;
        }
        const { DtData } = response;
        const [data] = DtData;
        const { ARNCode, Login_MailID } = data;

        const { user, arn } = jwt.decode(response.token);

        if (ARNCode !== arn || Login_MailID !== user) {
          this.props.userLogout();
          this.setState({
            username: { value: "" },
            password: { value: "" },
            otp: { value: "" },
            displayOTP: false,
            display: false,
          });
          alert("Unauthorized Request");
          return;
        }

        if (!response) {
          this.setState({
            username: { value: "" },
            password: { value: "" },
            otp: { value: "" },
            displayOTP: false,
            display: false,
          });
        }

        if (!!response && !!response.DtData && response.DtData.length > 0) {
          this.setState({
            display: false,
          });
          if (DtData[0].tran_enable_flag === "N") {
            this.props.history.push(DASHBOARD_URL);
          } else {
            this.props.history.push(`/new-transaction`);
          }
        } else if (!response) {
          this.setState({
            display: false,
            username: {
              value: "",
              isError: true,
              errorMessage: "Please enter valid details",
            },
            password: {
              value: "",
              isError: true,
              errorMessage: "Please enter valid details",
            },
          });
        }
      } catch (error) {
        this.setState({
          username: { value: "" },
          password: { value: "" },
          otp: { value: "" },
          displayOTP: false,
          display: false,
        }); // Handle error as needed
      }
    }
  };

  keyPress = (label) => (e) => {
    if (e.key === "Enter") {
      // Do code here
      if (label === "username") {
        this.passwordField.focus();
      } else {
        this.generateOTP();
      }
      e.preventDefault();
    }
  };
  closePoster = () => {
    this.setState({
      PosterOpen: false,
    });
  };
  closeModal = () => {
    this.setState({
      open: false,
    });
  };

  render() {
    const { username, password, otp } = this.state;
    return (
      <div>
        {/* <PosterDialog
                    open={this.state.PosterOpen}
                    close={this.closePoster}
                /> */}
        <PosterDialog
          open={this.state.displayPoster}
          close={() => 
            this.setState({
              displayPoster: false,
            })
          }
        />
        <CustomLoader display={!!this.state.display} />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 48,
          }}
        >
          <Image src={"/images/kfinkart-logo.svg"} alt="field_image" />
        </div>
        <div className="form_tabs_list">
          <span
            className="sign_in_btn sign_btn mouse-pointer"
            onClick={() => this.props.history.push("./login")}
          >
            Sign In
          </span>
          <span
            className="sign_up_btn sign_btn mouse-pointer"
            onClick={() => this.props.history.push("./register")}
          >
            Sign Up
          </span>
        </div>
        <Input
          isDark={true}
          bordercolor="#384455"
          className="Input-field-div-dark"
          placeholder={"User ID"}
          image={"/images/kfin_userid.svg"}
          name={"User ID"}
          // autoFocus={true}
          value={username.value}
          onChange={this.changeValue("username")}
          onBlur={this.showError("username")}
          isShowError={username.isError}
          errorMessage={username.errorMessage}
          inputref={(ele) => (this.usernameField = ele)}
          onKeyPress={this.keyPress("username")}
          autocomplete={"off"}
        />
        <div
          className="login-forgot mouse-pointer"
          onClick={() => this.props.history.push("./forgot-userid")}
        >
          Forgot User ID?
        </div>
        <Input
          type={!!this.state.showPassword ? "text" : "password"}
          isDark={true}
          bordercolor="#384455"
          className="Input-field-div-dark"
          placeholder={"Password"}
          name={"Password"}
          errorMessage={password.errorMessage}
          image={"/images/kfin_password.svg"}
          image2={
            !!this.state.showPassword
              ? "/images/kfin_eye_open.svg"
              : "/images/kfin_eye_close.svg"
          }
          height={18}
          value={password.value}
          onChange={this.changeValue("password")}
          onBlur={this.showError("password")}
          onClick={() => {
            this.setState({
              showPassword: !this.state.showPassword,
            });
          }}
          isShowError={password.isError}
          inputref={(ele) => (this.passwordField = ele)}
          onKeyPress={this.keyPress()}
          autocomplete={"off"}
        />
        <div
          className="login-forgot mouse-pointer"
          onClick={() => this.props.history.push("./forgot-password")}
        >
          Forgot Password?
        </div>
        {this.state.displayOTP && TWO_FA_ENABLED && (
          <>
            <Input
              name={"OTP"}
              value={this.state.otp.value}
              // autoFocus={true}
              isDark={true}
              bordercolor="#384455"
              className="Input-field-div-dark"
              onChange={this.changeValue("otp")}
              image={"/images/kfin_password.svg"}
              disabled={this.state.disabled}
              isShowError={otp.isError}
              type="number"
              placeholder={"Enter OTP"}
              errorMessage={otp.errorMessage}
              inputref={(ele) => (this.otpField = ele)}
              // onKeyDown={this.keyDown("otp")}
              onBlur={this.showError("otp")}
            />
          </>
        )}
        {/* <div>
          <ReCAPTCHA
            sitekey={process.env.REACT_APP_SITE_KEY}
            ref={this.captchaRef}
          />
        </div> */}

        {!this.state.displayOTP && TWO_FA_ENABLED && (
          <Signbutton
            buttontitle="Submit"
            onClick={this.generateOTP}
            isDark={true}
          />
        )}
        {(!TWO_FA_ENABLED || this.state.displayOTP) && (
          <Signbutton
            buttontitle="SIGN IN"
            onClick={this.signIn}
            isDark={true}
          />
        )}
        {this.state.displayOTP && TWO_FA_ENABLED && (
          <Signbutton
            buttontitle="Re-Generate OTP"
            onClick={this.generateOTP}
            isDark={true}
          />
        )}
        <EmailMobileRegistration
          open={this.state.open}
          close={this.closeModal}
          userid={username.value}
        />

        <div className="login-no-account">
          Don't have an account ?{" "}
          <span
            className="login-no-account-span mouse-pointer"
            onClick={() => this.props.history.push("./register")}
          >
            SIGN UP NOW
          </span>
        </div>
        <div style={{ textAlign: "center", marginTop: 30 }}>
          <a
            href="https://mfs.kfintech.com/mfs/Generalpages/KFinKart_termsconditions.aspx"
            target="_blank"
            style={{
              textAlign: "center",
              fontFamily: "OpenSans-Regular",
              fontSize: 15,
              color: "white",
              textDecoration: "underline",
              width: "100%",
            }}
          >
            Terms and Conditions*
          </a>
        </div>
      </div>
    );
  }
}

export default connect(
  ({ authReducer }) => {
    const { token, posterStatus } = authReducer;
    return {
      token,
      posterStatus,
    };
  },
  { userLogin, validateLoginOtp, generateLoginOtp, validateOTP, userLogout }
)(Login);

// export function AlertUp(message) {
//   return (
//     <div className="confirm" style={{width:500,height:500,position:"absolute"}}>
//         <div className="message">{message}</div>
//         <button className="yes">OK</button>
//       </div>
//   )
// }
export function encrypt(text) {
  const str = "acgredf7e2e";
  const str1 = "hseckahdfis234te";
  const decode = btoa(text);
  const encrpytion1 = str + decode + str1;
  const encrpyted = btoa(encrpytion1);
  return encrpyted;
}
